<template>
    <div class="fabu-evaluate-page">
        <!-- 顶部Header组件 -->
        <Header />

        <!-- 主体内容区域 -->
        <main class="content-wrapper">
            <!-- 面包屑导航 -->
            <div class="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/buyer' }">我的订单</el-breadcrumb-item>
                    <el-breadcrumb-item>订单详情</el-breadcrumb-item>
                    <el-breadcrumb-item>评价</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <!-- 评价表单区域 -->
            <div class="evaluate-form-container">
                <!-- 商品评价列表 -->
                <div class="goods-evaluate-list">
                    <!-- 单个商品评价项 -->
                    <div class="evaluate-item" v-for="(item, index) in evaluateForm" :key="index">
                        <!-- 商品信息 -->
                        <div class="goods-info">
                            <div class="goods-image">
                                <img :src="item.goods_thumb || ''" alt="商品图片" />
                            </div>
                            <div class="goods-details">
                                <div class="goods-name">{{ item.goods_name }}</div>
                                <div class="goods-spec">{{ item.sku_name }} {{ item.shop_price }}/{{ item.unit }}</div>
                                <!-- <div class="goods-price"></div> -->
                            </div>
                        </div>

                        <!-- 评价内容区域 -->
                        <div class="evaluate-content">
                            <!-- 星级评分 -->
                            <div class="evaluate-section" style="align-items: center;">
                                <span class="section-label">商品评价：</span>
                                <el-rate v-model="item.star" :max="5" />
                            </div>

                            <!-- 评价描述 -->
                            <div class="evaluate-section">
                                <span class="section-label">评价描述：</span>
                                <el-input v-model="item.content" type="textarea" :rows="3" placeholder="评价描述"
                                    class="evaluate-textarea" />
                            </div>

                            <!-- 图片/视频上传 -->
                            <div class="evaluate-section">
                                <span class="section-label">图片：</span>
                                <div class="upload-container">
                                    <ImageUpload :image-url="item.thumb" :max-files="9"
                                        @upload-success="handleImgUpload(2, $event, item)" />
                                    <div class="upload-tips">(图片最多9张)</div>
                                </div>
                            </div>

                            <!-- 匿名评价 -->
                            <div class="evaluate-section">
                                <el-checkbox v-model="item.type">匿名评价</el-checkbox>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 提交按钮 -->
                <div class="form-actions">
                    <el-button type="primary" @click="submitEvaluate" class="submit-btn">提交</el-button>
                </div>
            </div>

            <!-- 图片预览对话框 -->
            <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
        </main>

        <!-- 底部Footer组件 -->
        <Footer />
    </div>
</template>

<script>
// 导入Header和Footer组件
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
import ImageUpload from '@/components/ImageUpload.vue'

export default {
    name: 'FabuEvaluate',
    components: {
        Header,
        Footer,
        ImageUpload
    },
    data() {
        return {
            // 评价表单数据 - 支持多个商品评价
            evaluateForm: [

            ],
            // 图片预览对话框
            dialogImageUrl: '',
            dialogVisible: false
        }
    },
    created() {
        this.getPingjiaList()
    },
    methods: {
        // 返回上一页
        goBack() {
            this.$router.go(-1)
        },

        // 处理图片上传成功事件
        handleImgUpload(type, imageUrl, item) {
            if (type === 1) {
                item.thumb = imageUrl[0];
            } else if (type === 2) {
                item.thumb = imageUrl;
            } else if (type === 3) {
                item.product_certificate = imageUrl[0];
            }
        },

        // 获取评价列表
        getPingjiaList() {
            this.$api.getPingjiaList({
                aid: this.$route.query.orderId
            }).then(res => {
                this.evaluateForm = res
                this.evaluateForm.forEach(item => {
                    item.star = 5
                })
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 提交评价
        submitEvaluate() {
            // 这里可以添加表单验证和API调用逻辑
            const invalidItems = this.evaluateForm.filter(item => !item.star)
            if (invalidItems.length > 0) {
                this.$message.warning('请为所有商品评分')
                return
            }

            // 处理匿名评价
            this.evaluateForm.forEach(item => {
                if (item.type) {
                    item.type = 1
                } else {
                    item.type = 0
                }
            })

            // 提交评价
            let data = {
                order_id: this.$route.query.orderId,
                goods_comment: JSON.stringify(this.evaluateForm)
            }
            // console.log(this.evaluateForm);
            // return
            this.$dapi.submitPingjia(data).then(res => {
                this.$message.success('评价提交成功！')
                // 提交成功后跳转
                setTimeout(() => {
                    this.$router.go(-1)
                }, 1500)
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 图片预览
        handlePictureCardPreview(file, index) {
            this.dialogImageUrl = file.url
            this.dialogVisible = true
        },

        // 删除图片
        handleRemove(file, fileList, index) {
            this.evaluateForm[index].images = fileList
        }
    }
}
</script>

<style scoped>
.fabu-evaluate-page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #f5f5f5;
}

.content-wrapper {
    flex: 1;
    width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

.breadcrumb {
    margin-bottom: 20px;
    font-size: 14px;
}

.evaluate-form-container {
    background-color: #fff;
    border-radius: 4px;
    padding: 0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.goods-evaluate-list {
    padding: 20px;
}

.evaluate-item {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 20px;
    background-color: #fff;
}

.goods-info {
    display: flex;
    align-items: center;
    padding-bottom: 24px;
    justify-content: start;
    border-bottom: 1px solid #EEEEEE;
}

.goods-image {
    width: 80px;
    height: 80px;
    border: 1px solid #eee;
    border-radius: 4px;
    overflow: hidden;
    margin-right: 15px;
    flex-shrink: 0;
}

.goods-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.goods-details {
    flex: 1;
}

.goods-name {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333;
    margin-bottom: 5px;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    /* display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical; */
}

.goods-spec {
    display: flex;
    align-items: center;
    font-size: 14 px;
    color: #999;
    margin-bottom: 5px;
}

.goods-price {
    font-size: 14px;
    color: #666;
}

.evaluate-content {
    /* padding-left: 95px; */
    margin-top: 24px;
}

.evaluate-section {
    margin-bottom: 15px;
    display: flex;
    align-items: flex-start;
}

.section-label {
    font-size: 14px;
    color: #666;
    width: 80px;
    text-align: right;
    margin-right: 15px;
    /* margin-top: 8px; */
    flex-shrink: 0;
}

.evaluate-textarea {
    width: 100%;
    max-width: 500px;
}

.upload-container {
    /* flex: 1; */
    max-width: 500px;
}

.upload-container .el-upload--picture-card {
    width: 80px;
    height: 80px;
}

.upload-tips {
    font-size: 12px;
    color: #999;
    margin-top: 10px;
}

.form-actions {
    display: flex;
    justify-content: center;
    padding: 20px;
    background-color: #fff;
    border-top: 1px solid #e0e0e0;
}

.submit-btn {
    width: 120px;
    height: 40px;
    font-size: 16px;
    background-color: #286CED;
    border-color: #286CED;
}
</style>